import React, { Component } from 'react';
import '../../Style/sidebar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import * as sidebarActions from '../../Store/Actions/sidebarActions';

//Components


class Sidebar extends Component {
    // constructor(props) {
    //   super(props);
    //   // State is in reducers
    // }
  createContent = () => {
    var data = this.props.sidebarContent;
    var items = data.map((dataItem, i) => {
      return (
        <div className="sidebar-line" key={i}>
          <h3 onClick={this.onClickItem.bind(this, i, 0)} className={dataItem.isActive ? "active" : "inactive"}>{dataItem.name}</h3>
          <ul className={dataItem.isExpendable?"show":"hide"}>
            {
              dataItem.children.map((subItem, j) => {
                return (
                  <li key={j} onClick={this.onClickItem.bind(this, i, j)} className={subItem.isActive ? "active" : "inactive"}>{subItem.name}</li>
                )
              })
            }
          </ul>
        </div>
      )
    });



    return (
      <div className="Sidebar-Content">
        {items}
      </div>
    )
  }

  onClickItem = (i,j) => {
    this.props.switchMenuItem(i,j);
  }

  render() {
    var content = this.createContent();


    return (
      <div className={this.props.sidebarShow ? "Sidebar show" : "Sidebar hide"}>
        {/* <div className="Sidebar-header"></div> */}
        
          {content}
        <div className="Sidebar-nav" onClick={this.props.toggleSidebar}>
          <FontAwesomeIcon icon="bars" />
        </div>
      </div>
    );
  }
}
  
const mapStateToProps = (state) => {  
  return {   
    sidebarShow: state.appReducer.sidebarShow,
    sidebarContent: state.appReducer.sidebarContent,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    toggleSidebar: (props) => dispatch(sidebarActions.toggleSidebar(props)),
    switchMenuItem: (i,j) => dispatch(sidebarActions.switchMenuItem(i,j)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
  